import { Component, ViewEncapsulation, input, output } from '@angular/core';
import { SelectOption } from '@agilox/ui-common';
import { SelectCustomOptionDirective } from '../../directives';

@Component({
	selector: 'ui-select-option',
	templateUrl: './select-option.component.html',
	encapsulation: ViewEncapsulation.None,
	standalone: false,
})
export class SelectOptionComponent {
	option = input<SelectOption<any> | null>(null);
	selected = input<boolean>(false);
	multiEnabled = input<boolean>(false);
	focused = input<boolean>(false);
	customOptionTemplate = input<SelectCustomOptionDirective | undefined>(undefined);
	disabled = input<boolean | undefined>(false);
	fullWidth = input<boolean>(false);

	optionSelected = output<SelectOption<any>>();

	emitSelectedOption(): void {
		const currentOption = this.option();
		if (currentOption && !currentOption.isDisabled) {
			this.optionSelected.emit(currentOption);
		}
	}
}
